import OnlineMembershipTriage from './triage.class';

window.addEventListener('DOMContentLoaded', function(){

    if ( $('#OnlineMembershipTriage').length )
    {
        const triage = new OnlineMembershipTriage('OnlineMembershipTriage');

        $('.jsTriageSubmitAnswer').on('click', function(e){
            e.preventDefault();
    
            let answer = $(this).data('answer');
    
            $(this).parents('.jsTriageQuestion').find('.jsTriageAnswer').val(answer);
    
            triage.step++;
        });

        $('.jsTriageGoBack').on('click', function(e){
            e.preventDefault();
            triage.step--;
        });
    }

});